// extracted by mini-css-extract-plugin
export default {"InfoBert":"InfoBertUmQ3HeCm6VKf","InfoBert-avatar":"InfoBert-avatar3WJmAuktx50m","InfoBert-icon":"InfoBert-iconQEK5KySqlV5s","InfoBert-content":"InfoBert-content2x5hNvqNsD6w"};